import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from '../../utils/api';

export const useGetRequiredDocumentsQuery = () => {
  const fetchRequiredDocuments = async (): Promise<RequiredDocumentResponse> => {
    return (await api.get('/AdmissionDocument/Admin/GetAllRequiredDocuments'))?.data;
  };

  const { data, isLoading, isError, error, refetch } = useQuery<
    RequiredDocumentResponse,
    AxiosError<ApiErrorResponse>
  >({
    queryKey: ['get-required-documents'],
    queryFn: fetchRequiredDocuments,
  });

  const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch required documents';

  return {
    requiredDocumentsData: data?.data ?? [],
    isRequiredDocumentsLoading: isLoading,
    isRequiredDocumentsError: isError,
    requiredDocumentsErrorMessage: errorMessage,
    refetch,
  };
};
